<div class="card">
  <div class="card-header card-no-border">
    <div class="header-top">
      <h5>{{ 'Activity Hours' | translate }}</h5>
      <div class="dropdown icon-dropdown">
        <button class="btn dropdown-toggle" (click)="toggle()" type="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="icon-more-alt"></i></button>
        <div class="dropdown-menu dropdown-menu-end" [class.show]="show" ><a class="dropdown-item" href="#">{{ 'Today' | translate }}</a><a class="dropdown-item" href="#">{{ 'Tomorrow' | translate }}</a><a class="dropdown-item" href="#">{{ 'Yesterday ' | translate }}</a></div>
      </div>
    </div>
  </div>
  <div class="card-body pt-0">
    <div class="row m-0 overall-card">
      <div class="col-xl-8">
        <div class="chart-right">
          <div class="row">
            <div class="col-xl-12">
              <div class="card-body p-0">
                <div class="activity-wrap">
                  <div id="activity-chart">
                     <apx-chart [series]="activityChart.series" [chart]="activityChart.chart" [plotOptions]="activityChart.plotOptions" [dataLabels]="activityChart.dataLabels" [xaxis]="activityChart.xaxis" [yaxis]="activityChart.yaxis" [grid]="activityChart.grid" [colors]="activityChart.colors" [fill]="activityChart.fill" [responsive]="activityChart.responsive"></apx-chart>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-4 p-0">
        <div class="row g-sm-3 g-2 mt-0">
          <div class="col-xl-12 col-md-6 col-sm-4">
            <div class="light-card balance-card">
              <div>
                <span class="f-light">{{ 'Time Spent' | translate }}</span>
                <h6 class="mt-1 mb-0">{{ '30' | translate }}<span class="badge badge-light-success rounded-pill ms-1">{{ '140%' | translate }}</span></h6>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-md-6 col-sm-4">
            <div class="light-card balance-card">
              <div>
                <span class="f-light">{{ 'Lessons taken' | translate }}</span>
                <h6 class="mt-1 mb-0">{{ '45' | translate }}<span class="badge badge-light-success rounded-pill ms-1">{{ '86%' | translate }}</span></h6>
              </div>
            </div>
          </div>
          <div class="col-xl-12 col-md-6 col-sm-4">
            <div class="light-card balance-card">
              <div>
                <span class="f-light">{{ 'Exams passed' | translate }}</span>
                <h6 class="mt-1 mb-0">{{ '12' | translate }}<span class="badge badge-light-success rounded-pill ms-1">{{ '120%' | translate }}</span></h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
